import { createApp } from 'vue';
import WavToMp3Converter from '@/Components/WavToMp3Converter.vue';
import '@styles/app.css';

createApp(WavToMp3Converter).mount('#wav-to-mp3-converter');
